<div mat-dialog-content>
  <button mat-mini-fab aria-label="Close" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
  <google-map width="100%" height="60vh" [options]="options" [center]="data.currentPosition">
    <map-circle [center]="data.destination" [radius]="10000" [options]="circleOptions" />
    <map-advanced-marker [position]="data.currentPosition" />
  </google-map>
</div>
